import React from "react";
import { Grid, Box } from "@material-ui/core";
import {
  TextField,
  ArrayField,
  Datagrid,
  Button,
  useRecordContext,
  TopToolbar,
  DateField,
} from "react-admin";
import { deepRedirect } from "../../../utils/utils";
import { CreateIcon, EditIcon } from "../../../components/common/iconography";

export const ChecklistPanel = (props) => {
  const { record, backPath, history } = props;

  const handleCreate = () => {
    deepRedirect(history, `/checklists/create`, backPath, {
      resourceId: record.id,
      allowCopy: true,
    });
  };

  return (
    <>
      <Box width="100%">
        <TopToolbar>
          <Button
            label="Create"
            color="primary"
            onClick={handleCreate}
            disabled={!record?.id || record?.checklists?.items?.length === 10}
          >
            <CreateIcon />
          </Button>
        </TopToolbar>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <SortedArrayField {...props} sortField="name" sort="ASC" />
        </Grid>
      </Grid>
    </>
  );
};

const SortedArrayField = (props) => {
  const { record } = props;
  const list = record["checklists"]?.items || [];
  const sortedList = list?.sort((a, b) => a.name.localeCompare(b.name));
  const modifiedRecord = { ...record, checklists: { items: sortedList } };

  return (
    <ArrayField record={modifiedRecord} source="checklists.items">
      <Datagrid bulkActionButtons={false}>
        <TextField source="name" />
        <TextField source="processName" label="Process Name" />
        <TextField source="active" />
        <DateField source="createdAt" label="Create Date" />
        <EditButton {...props} />
      </Datagrid>
    </ArrayField>
  );
};

const EditButton = (props) => {
  const { backPath, history } = props;
  const record = useRecordContext();

  const handleEdit = (evt, record) => {
    deepRedirect(history, `/checklists/${record.id}`, backPath);
  };

  return (
    <Button
      label="Edit"
      size="small"
      color="primary"
      onClick={(evt) => handleEdit(evt, record)}
    >
      <EditIcon />
    </Button>
  );
};
